import React, { memo } from 'react';

import Symbol from '@/components/atomic/atoms/data-display/icons/symbol';
import IconNames from '@/components/atomic/atoms/data-display/icons/symbol/enum';
import withExposer from '@/hocs/with-exposer';
import { BasicComponentProps } from '@/typings/generic';

const IconSliceComponent: React.FC<BasicComponentProps> = ({
	$exposerSuffix,
}) => (
	<Symbol
		$exposerSuffix={$exposerSuffix}
		id={IconNames.LOCATION}
		viewBox={[0, 0, 16, 19]}
		dangerouslySetInnerHTML={{
			__html: '<path d="M3.731 12.83l1.891 1.417a3.953 3.953 0 0 1 1.587 3.17v.792a.792.792 0 0 0 1.583-.001v-.792c0-1.298.624-2.448 1.587-3.17l1.893-1.417a7.114 7.114 0 0 0 2.853-5.689v-.035A7.125 7.125 0 1 0 3.731 12.83zM8 1.583a5.542 5.542 0 0 1 2.85 10.297l-2.441 1.467a.791.791 0 0 1-.816 0L5.15 11.878A5.542 5.542 0 0 1 8 1.583z"></path><circle cx="8" cy="7.125" r="2.375"></circle>',
		}}
	/>
);

const IconSlice = memo(withExposer(IconSliceComponent, 'iconSlice_LOCATION'));

export default IconSlice;
